module.exports="#define GLSLIFY 1\nvarying vec3 vNormal;\nvarying vec3 vColor;\n\nvoid main() {\n    gl_FragColor = vec4(0.3*vColor, 1.0);\n}\n";